import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { GenModel, GenModel1 } from '../models/candidateprofile-genmodel';
import { Observable, timer } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { map, retry } from 'rxjs/operators';
export interface Candprofile {
  screenName: string;
  candidateId: number;
  applicationId: number;
  companyHiringTypeId: number;
}
@Injectable({
  providedIn: 'root',
})
export class DynamicCandidateProfileService {
  getGenModelUrl: string = environment.schedulerDashboardUrl;
  getfileurl: string = environment.mongoApiUrl;
  wrapperUrl = environment.careerUrl;
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  private textOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8'),
    responseType: 'text' as 'json',
  };
  bool: boolean = false;
  retryDelay: number = window["retryDelay"];

  constructor(private httpclient: HttpClient) {}

  getdata(body) {
    return this.httpclient.post<GenModel1>(this.getGenModelUrl + 'editGenModelStructure', body);
  }

  saveAddressProof(body) {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<any>(this.getGenModelUrl + 'saveAddressProof', body, requestOptions);
  }
  setBool(bool) {
    this.bool = bool;
  }

  getBool() {
    return this.bool;
  }

  saveDocumentId(body) {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<any>(this.getGenModelUrl + 'saveDocumentId', body, requestOptions);
  }

  getImageData(ojectId, ojectType, attachmentId) {
    return this.httpclient.get<any>(this.getfileurl + 'getFileId/' + ojectId + '/' + ojectType + '/' + attachmentId);
  }

  public deleteFile(fileID) {
    const uploadURL = this.getfileurl + 'deleteFileData?id=' + fileID;
    return this.httpclient.post(`${uploadURL}`, '', this.textOptions);
  }

  getImage(id) {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.httpclient.get<any>(this.getfileurl + 'downloadFileNew', { params: params });
  }

  uploadImageData(data) {
    console.log(data);
    const uploadURL = this.getfileurl + 'uploadFileData';
    const requestOptions: object = {
      reportProgress: true,
      observe: 'events',
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
    };

        const request$ =  this.httpclient.post<any>(uploadURL, data, requestOptions).pipe(map((event) => {

            switch (event.type) {

                case HttpEventType.UploadProgress:
                case HttpEventType.Response:
                    return event.body;
                default:
                    return `Unhandled event: ${event.type}`;
            }
        }));
        return this.retryDelay
            ? request$.pipe(retry({
                count: 1, delay: (error) => {
                    if (error instanceof HttpErrorResponse && error.status === 502) {
                        console.log('retrying now...');
                        return timer(this.retryDelay);
                    }
                    throw error;
                }
            }))
            : request$;


    }

   


  editGapsInfo(wrapperBody): Observable<any> {
    // let encodedEmailId = encodeURIComponent(emailId);
    return this.httpclient.post<any>(
      this.wrapperUrl + 'candidateWrapperServices/saveCandidateWrapperServices',
      wrapperBody,
      this.textOptions,
    );
  }

  deleteExperience(expIdList): Observable<any> {
    return this.httpclient.post<any>(
      this.wrapperUrl + 'v1/candidate/deleteExperienceDetails',
      expIdList,
      this.textOptions,
    );
  }

  deleteEducation(eduIdList): Observable<any> {
    return this.httpclient.post<any>(
      this.wrapperUrl + 'v1/candidate/deleteEducationDetails',
      eduIdList,
      this.textOptions,
    );
  }

  deleteAddress(addrIdList): Observable<any> {
    return this.httpclient.post<any>(
      this.wrapperUrl + 'v1/candidate/deleteAddressDetails',
      addrIdList,
      this.textOptions,
    );
  }

  editgenmodel(body) {
    return this.httpclient.post<GenModel>(this.getGenModelUrl + 'editGenModelStructure', body);
  }

  getAllFiles(expId, objectType): Observable<any> {
    return this.httpclient.get<any>(this.getfileurl + 'getAllFiles/' + expId + '/' + objectType);
  }

  ParserAIUpload(resumeParserAI): Observable<any> {
    return this.httpclient.post<any>(this.getGenModelUrl + 'Resume/aiParserUpload', resumeParserAI, this.textOptions);
  }
}
